// store/slices/userSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import loginApi from '@/service/modules/loginApi';
import { setCookie } from '@/utils/cookie'

// 定义客户信息接口
interface CustomerInfo {
  firstName?: string;
  lastName?: string;
  customerID?: string | number;
  addressID?: number;
  billingAddressID?: number;
  [key: string]: string | number | boolean | undefined;
}

interface UserState {
  customerInfo: CustomerInfo;
  hasLogin: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  customerInfo: {},
  hasLogin: false,
  loading: false,
  error: null
};

// 创建异步thunk action来获取用户信息
export const fetchCustomerInfo = createAsyncThunk(
  'user/fetchCustomerInfo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await loginApi.me();
      if (response.data && !response.data.customerID) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userEmail');
        setCookie('userCustomerId', '');
      }
      return response.data;
    } catch (error) {
      localStorage.removeItem('userToken');
      localStorage.removeItem('userEmail');
      setCookie('userCustomerId', '');
      return rejectWithValue('Failed to fetch customer info');
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<CustomerInfo>) => {
      state.customerInfo = action.payload;
      state.hasLogin = !!action.payload.customerID;
    },
    clearUserInfo: (state) => {
      state.customerInfo = {};
      state.hasLogin = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerInfo.fulfilled, (state, action: PayloadAction<CustomerInfo>) => {
        state.loading = false;
        state.customerInfo = action.payload;
        state.hasLogin = !!action.payload.customerID;
      })
      .addCase(fetchCustomerInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export const { setUserInfo, clearUserInfo } = userSlice.actions;
export default userSlice.reducer;